const CONSULTING_REQUEST_TYPE = {
  BIOFLUX_TRADE_IN: 'BIOFLUX_TRADE_IN',
  RPM_CCM_SERVICE: 'RPM_CCM_SERVICE',
};

const SUBJECT_CONSULTING_REQUEST = {
  biofluxTradeIn: 'biofluxTradeIn',
  rpmCcmService: 'rpmCcmService',
};

export { CONSULTING_REQUEST_TYPE, SUBJECT_CONSULTING_REQUEST };
